
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">

<header> <app-menu></app-menu></header>




<main>
  <router-outlet></router-outlet>

  <form [formGroup]="formulario">
    <input id="nome" type="text" class="form-control" formControlName="nome"  placeholder="Nome" >
    <div *ngIf="formulario.get('nome')?.errors?.['required'] && formulario.get('nome')?.touched" class="text-danger">
      Nome obrigatório
    </div>
  
  

    <input id="username" type="text" class="form-control" formControlName="username" placeholder="Username" >

    <div *ngIf="formulario.get('email')?.errors?.['required'] && formulario.get('email')?.touched" class="text-danger">
      Email obrigatório
    </div>
    <div *ngIf="formulario.get('email')?.errors?.['pattern']" class="text-danger">
      Email inválido
    </div>
    <input id="email" type="email" class="form-control" formControlName="email" placeholder="Email">
    <div *ngIf="formulario.get('senha')?.errors?.['required'] && formulario.get('senha')?.touched" class="text-danger">
      Senha obrigatória
    </div>
    <div *ngIf="formulario.get('senha')?.errors?.['pattern']" class="text-danger">
      Senha inválida (mínimo de 8 caracteres, pelo menos uma letra e um número)
    </div>
    <input id="senha" type="password" class="form-control" formControlName="senha" placeholder="Senha">
    <button [disabled]="!formulario.valid" (click)="cadastrarUsuario()">
      Cadastre-se
    </button>
    <button (click)="testLocalStorage()">Testar LocalStorage</button>    
    <div *ngIf="mostrarResultado">
      <p>Resultado do LocalStorage: {{ resultadoLocalStorage | json }}</p>
    </div>
  </form>
</main>

 <app-donation></app-donation>
<app-button></app-button> 

<div class="container">  
  <app-father> Pai rodando</app-father>
</div> 
<app-crud></app-crud>
<app-footer></app-footer>


